import { ProductConnectionCategoryType } from '@genoa/state-management'

import { useLazyGetAccountV3Query } from '../modules/flexApi'
import { useLogger } from '../providers/logger'

export const useAccountV3 = () => {
  const [getAccountV3Query, { isLoading: isGetAccountV3Loading }] = useLazyGetAccountV3Query()
  const logger = useLogger('useAccountV3')

  /**
   * Check if the customer is connected to the MOVE_IN product
   * @param customerId - The customer ID
   * @returns True if the customer is connected to the MOVE_IN product, false otherwise
   */
  const checkMoveInConnection = async (customerId: string) => {
    try {
      const account = await getAccountV3Query({
        customerId,
        categoryType: ProductConnectionCategoryType.MOVE_IN,
      }).unwrap()
      return account.data.productConnections[0].categoryType === ProductConnectionCategoryType.MOVE_IN
    } catch (error: any) {
      logger.error('Error checking useAccountV3', error?.message)
      return false
    }
  }

  return {
    checkMoveInConnection,
    isGetAccountV3Loading,
  }
}
